import Link from '@mui/material/Link';
import Typography from '@mui/material/Typography';
import { FormattedMessage } from 'react-intl';
import { useNavigate } from 'react-router-dom';
import { PATHS } from '../../config/consts';
import { useUrlParams } from '../../helpers/urlParams';
import DeleteDevicesList from './DeleteDevicesList';
import messages from './messages';

export interface IDevices {
  deviceId: string;
  deviceName: string;
  deviceType: string;
}

export interface IGroup {
  apartments: number;
  devices: IDevices[];
  id: number | string;
  name: string;
  users: number;
}

export interface IDialogBodyProps {
  group: IGroup;
  onClose: () => void;
}

const defaultGroup = {
  apartments: 0,
  devices: [],
  id: '',
  name: '',
  users: 0,
};

function DialogBody({ group = defaultGroup, onClose }: IDialogBodyProps) {
  const navigate = useNavigate();
  const { companyId, siteId } = useUrlParams();
  const { apartments, devices, id, name, users } = group;

  // eslint-disable-next-line complexity
  const getBodyMesage = () => {
    if (!!devices?.length && !!users && !!apartments) {
      return messages.accessGroupDeleteModalDialogBodyApartmentsUsersDevices;
    }

    if (!!devices?.length && !!apartments && !users) {
      return messages.accessGroupDeleteModalDialogBodyNoUsers;
    }

    if (!!devices?.length && !!users && !apartments) {
      return messages.accessGroupDeleteModalDialogBodyNoApartments;
    }

    if (!devices?.length) {
      return messages.accessGroupDeleteModalDialogBodyNoDevices;
    }

    return messages.accessGroupDeleteModalDialogBodyNoApartmentsNoUsers;
  };

  function handleLinkClick(path: string) {
    onClose();
    if (companyId && siteId) {
      navigate(
        path
          .replace(':companyId', companyId.toString())
          .replace(':siteId', siteId.toString())
          .replace(':groupId', id.toString())
      );
    }
  }

  return (
    <>
      <Typography component="span" variant="body1">
        <FormattedMessage
          {...getBodyMesage()}
          values={{
            apartmentLink: (chunks) => (
              <MessageLink onClick={() => handleLinkClick(PATHS.ACCESS_SETTINGS_APARTMENTS)}>{chunks}</MessageLink>
            ),
            apartments,
            devices: devices?.length,
            groupName: <strong>{name}</strong>,
            p: (chunks) => <p>{chunks}</p>,
            strong: (chunks) => <strong>{chunks}</strong>,
            users,
            usersLink: (chunks) => (
              <MessageLink onClick={() => handleLinkClick(PATHS.ACCESS_SETTINGS_USERS)}>{chunks}</MessageLink>
            ),
          }}
        />
      </Typography>
      {(!!users || !!apartments) && !!devices?.length && <DeleteDevicesList devices={devices} />}
    </>
  );
}

function MessageLink({ ...other }) {
  return (
    <Link
      {...other}
      sx={{
        cursor: 'pointer',
        fontWeight: 'bold',
      }}
    />
  );
}

export default DialogBody;
